// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { triangleFilled16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-triangle-filled': IconTriangleFilled;
    }
}

/**
 * The icon component for the 'triangleFilled' icon
 */
export class IconTriangleFilled extends Icon {
    public constructor() {
        super(triangleFilled16X16);
    }
}

registerIcon('icon-triangle-filled', IconTriangleFilled);
export const iconTriangleFilledTag = 'nimble-icon-triangle-filled';
